"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function copyToClipboard(str) {
  var el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

exports.copyToClipboard = copyToClipboard;